import { motion } from "framer-motion";

export default function Careers() {
  const roles = [
    "Annotation & Transcription Tasks",
    "Freelance Linguists & Voice Artists",
    "Full-Time Roles in Project & Data Operations"
  ];

  const benefits = [
    "Remote global opportunities",
    "Flexible schedules",
    "Competitive pay",
    "Work on impactful AI projects"
  ];

  return (
    <section className="py-28 px-6 bg-gradient-to-br from-black via-gray-900 to-black text-white">
      <div className="max-w-4xl mx-auto bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 rounded-3xl shadow-2xl p-10 text-center border border-gray-700">

        {/* Heading */}
        <h2 className="text-4xl font-extrabold mb-4 tracking-tight font-orbitron">
          Join The Prisu Experts Network
        </h2>
        <p className="text-lg text-gray-300 mb-10 font-raleway">
          Help shape the future of AI by contributing your skills to global data and language projects.
        </p>

        {/* Roles */}
        <div className="mb-10 text-left">
          <h3 className="text-2xl font-semibold mb-4 text-white font-raleway">Opportunities for:</h3>
          <ul className="space-y-4">
            {roles.map((role, index) => (
              <li key={index} className="flex items-start gap-3 text-gray-200">
                <motion.span
                  animate={{ scale: [1, 1.3, 1] }}
                  transition={{ repeat: Infinity, duration: 2, delay: index * 0.2 }}
                  className="text-indigo-400 text-xl mt-1"
                >
                  📌
                </motion.span>
                <span className="text-base leading-relaxed">{role}</span>
              </li>
            ))}
          </ul>
        </div>

        {/* Benefits */}
        <div className="mb-12 text-left">
          <h3 className="text-2xl font-semibold mb-4 text-white font-raleway">Why Join Us:</h3>
          <ul className="space-y-4">
            {benefits.map((benefit, index) => (
              <li key={index} className="flex items-start gap-3 text-gray-200">
                <motion.span
                  animate={{ scale: [1, 1.3, 1] }}
                  transition={{ repeat: Infinity, duration: 2.5, delay: index * 0.3 }}
                  className="text-green-400 text-xl mt-1"
                >
                  ✅
                </motion.span>
                <span className="text-base leading-relaxed">{benefit}</span>
              </li>
            ))}
          </ul>
        </div>

        {/* Apply Now Button */}
        <motion.a
          whileHover={{ scale: 1.1 }}
          whileTap={{ scale: 0.95 }}
          href="https://docs.google.com/forms/d/e/1FAIpQLSem4mVbTOTRImluD5ub1E9-NVZhUyzMm-bHgM6tL4a8-j7N7Q/viewform?usp=header"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-block bg-indigo-600 hover:bg-indigo-700 transition duration-300 px-8 py-3 rounded-full text-white font-bold text-lg shadow-md"
        >
          Apply Now →
        </motion.a>
      </div>
    </section>
  );
}
